import { render, staticRenderFns } from "./SwitchView.vue?vue&type=template&id=720f867c&scoped=true"
import script from "./SwitchView.vue?vue&type=script&lang=js"
export * from "./SwitchView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720f867c",
  null
  
)

export default component.exports